import * as React from 'react';

interface IProductTagsProps {
  language?: string;
  tags: GQL.IProductTag[];
  variant: GQL.IProductVariant;
}

class ProductTags extends React.Component<IProductTagsProps> {

  render() {
    // todo: language nikdy nepřijde v props !!! to musí bát globální informace
    const { language, variant } = this.props;

    const tagsInProduct = variant.product.tags;

    if (!tagsInProduct) {
      return null;
    }

    return (
      <div className="productTags">
        {this.props.tags &&
          this.props.tags.map((tag: GQL.IProductTag) => {

            // má produkt tento tag ?
            if (tagsInProduct && tagsInProduct.find((tagId: string) => tagId === tag.id)) {
              let title = tag.title[language || 'en']; // todo: fuj
              if (title) {
                // tag se zobrazením slevy
                const isDiscount = title.search('{discount}') >= 0;
                if (isDiscount) {
                  // todo: ceny z prices !!!!!!!!!
                  console.log('Předělej detekci cen !!!!')
                  const recommendedPrice = variant.recommendedPrice ? variant.recommendedPrice : variant.product.recommendedPrice;
                  const price = variant.price ? variant.price : variant.product.price;
                  let discount = price && recommendedPrice ? recommendedPrice - price : 0;

                  if (!recommendedPrice || !price) {
                    return null;
                  }

                  // produkt není zlevněný
                  if (discount <= 0) {
                    return null;
                  }

                  title = title.replace('{discount}', `${recommendedPrice ? 0 - Math.round((discount / recommendedPrice) * 100) : 0}%`);
                }
              }

              return (
                <div key={tag.id}>
                  <span className={`productTag[${tag.slug}]`} style={{ backgroundColor: tag.color || '' }}>
                    {title}
                  </span>
                </div>
              );
            }

            return null;
          })}
      </div>
    );
  }
}

export default ProductTags;


// WEBPACK FOOTER //
// ./src/scenes/Catalog/components/ProductTags.tsx